export function buildCompatibilityFilters(
  attributes: {
    key: string
    values: string[]
  }[],
) {
  return attributes
    .map(({ key, values }) => {
      const valuesCopy = !values.includes('compatible_to_all')
        ? [...values, 'compatible_to_all']
        : values

      return `(${valuesCopy.map((value) => `${key}:'${value}'`).join(' OR ')})`
    })
    .concat('compatibility_accessory:true')
    .join(' AND ')
}

export function buildFallbackCompatibilityFilters(
  attributes: {
    key: string
    values: string[]
    score?: number
  }[],
) {
  return attributes
    .map(({ key, values, score }) => {
      const valuesCopy = !values.includes('compatible_to_all')
        ? [...values, 'compatible_to_all']
        : values

      return `(${valuesCopy.map((value) => `${key}:'${value}'${value !== 'compatible_to_all' && score ? `<score=${score}>` : ''}`).join(' OR ')})`
    })
    .concat('compatibility_accessory:true')
    .join(' AND ')
}
